import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SummaryState } from './summary.state';

import { PurchaseState } from '@shared/purchase/store/purchase.state';

const selectSummaryState = createFeatureSelector<SummaryState>('summary');

const selectPurchaseState = createFeatureSelector<PurchaseState>('purchase');

export const getCoupons = createSelector(
    selectSummaryState,
    (summaryState: SummaryState) => {
        return summaryState?.values;
    }
);

export const getSelectedCoupon = createSelector(
    selectPurchaseState,
    (purchaseState: PurchaseState) => {
        return purchaseState?.attempt?.values?.adjustment?.find((adjustment) => !!adjustment.couponCode);
    }
);

export const getSelectedCouponCode = createSelector(
    selectPurchaseState,
    (purchaseState: PurchaseState) => {
        return purchaseState?.attempt?.values?.adjustment?.find((adjustment) => !!adjustment.couponCode)?.couponCode;
    }
);

export const getCouponsError = createSelector(selectSummaryState, (summaryState: SummaryState) => {
    return summaryState?.errors;
});

export const getLoadingStatus = createSelector(selectSummaryState, (summaryState: SummaryState) => {
    return summaryState?.status;
});
